const info = new window.Browser()
const browser = info.browser
const envName =
  (window.config && window.config.VUE_APP_ENV_NAME) ||
  process.env.VUE_APP_ENV_NAME

let currentBrowser = 'other'

/**
 * 判断是否为IE浏览器
 * @type {boolean}
 */
export const isIE =
  browser === 'IE' &&
  window.navigator.userAgent.msManipulationViewsEnabled === true

if (isIE) {
  currentBrowser = 'ie'
}

/**
 * 判断是否为IE浏览器
 * @type {boolean}
 */
export const isChrome = browser === 'Chrome'

if (isChrome) {
  currentBrowser = 'chrome'
}

/**
 * 判断是否为IE浏览器
 * @type {boolean}
 */
export const is360Chrome =
  /^360(EE|SE)?$/g.test(browser) ||
  (browser === 'IE' && window.navigator.msManipulationViewsEnabled === false) ||
  false

if (is360Chrome) {
  currentBrowser = '360chrome'
}

/**
 * 判断当前浏览器类型，在支持的浏览器内打开地址
 * @param url 打开的链接
 * @param targetBrowsers 支持的浏览器
 * @param target 打开方式
 */
export const open = (url, targetBrowsers = '', target = '_blank') => {
  if (!targetBrowsers) {
    return window.open(url, target)
  }
  const browserList = targetBrowsers.split(',') || []
  // 如果支持的浏览器包含当前浏览器，则用当前浏览器打开
  if (browserList.includes(currentBrowser)) {
    return window.open(url, target)
  } else {
    // 如果当前浏览器没有被支持，则打开其他浏览器
    const newUrl = new URL(url)
    const usp = new URLSearchParams(newUrl.search)
    usp.append('origin', envName)
    usp.append(
      'explorer',
      targetBrowsers
        .replace(/ie/gi, 'IEXPLORE.EXE')
        .replace(/chrome/gi, 'chrome.exe')
    )
    newUrl.search = '?' + usp.toString()
    const decodedUrl = encodeURIComponent(newUrl.href)
    return window.open(`ExploreProxy:${decodedUrl}`, target)
  }
}

/**
 * 在body上增加browser-type属性
 */
export const addAttrInBody = () => {
  const UA = window.navigator.userAgent.toLowerCase()
  const isIE = /msie|trident/.test(UA)
  if (isIE) {
    document.body.setAttribute('browser-type', 'ie')
  }
}
